module.exports = {
  ACCOUNT_PRIMARY_CONTACTS: "account-primary-contacts",
  ACCOUNT_CONTACT_USERS: "account-contact-users",
  CONTACT: "contact",
  CONTACT_AND_ADDITIONAL_CONTACTS: "contact-and-additional-contacts",
  EMAIL_FIELD: "email-field",
  CONTACT_LOOKUP: "contact-lookup",
  ACCOUNT_LOOKUP_PRIMARY_CONTACTS: "account-lookup-primary-contacts",
  ACCOUNT_LOOKUP_CONTACT_USERS: "account-lookup-contact-users",
  ORDER_CUSTOMER: "order-customer",
  SESSION_SPEAKERS: "session-speakers",
  SESSION_SPEAKERS_AND_ADDITIONAL_CONTACTS:
    "session-speakers-and-additional-contacts",
  SESSION_OWNERS: "session-owners",
  APPLICANTS: "applicants",
  SELECT_INDIVIDUAL_CONTACTS: "select-individual-contacts",
  //
  PHONE_FIELD: "phone-field"
};
